import React from "react";

const statusMessages = [
  "Connecting to app",
  "Checking your line",
  "Loading your plan",
];

const padDelays = ["0s", ".16s", ".32s", ".48s", ".64s", ".80s"];

const S4SSimLoading = () => {
  return (
    <div
      className="fixed inset-0 z-[9999] flex select-none flex-col items-center justify-center overflow-hidden bg-[linear-gradient(168deg,#1B1960_0%,#2E2B8F_46%,#3A37A4_100%)] font-poppins text-white"
      role="status"
      aria-live="polite"
      aria-label="Loading S4S SIM"
    >
      <div className="s4s-ambient pointer-events-none absolute left-1/2 top-[46%] h-[560px] w-[560px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(40,160,227,.32)_0%,rgba(40,160,227,0)_62%)]" />

      <div className="relative flex flex-col items-center gap-[34px]">
        <div className="relative flex h-[132px] w-[132px] items-center justify-center">
          <div className="s4s-ring absolute h-[132px] w-[132px] rounded-full border-2 border-[rgba(120,200,255,.55)] opacity-0" />

          <svg
            className="h-[132px] w-24 max-[380px]:h-[116px] max-[380px]:w-[84px]"
            viewBox="0 0 96 132"
            aria-hidden="true"
          >
            <path
              className="fill-[rgba(255,255,255,.06)] stroke-[rgba(255,255,255,.42)] [stroke-width:2]"
              d="M13 1h56l26 26v92a12 12 0 0 1-12 12H13A12 12 0 0 1 1 119V13A12 12 0 0 1 13 1Z"
            />
            <path
              className="fill-none stroke-[rgba(255,255,255,.22)] [stroke-width:1.5]"
              d="M69 1v14a12 12 0 0 0 12 12h14"
            />
            <path
              className="fill-none stroke-[rgba(255,255,255,.22)] [stroke-width:1.5]"
              d="M48 40v54M14 67h68"
            />

            {padDelays.map((delay, index) => {
              const isLeftColumn = index % 2 === 0;
              const row = Math.floor(index / 2);

              return (
                <rect
                  key={delay}
                  className="s4s-pad fill-[rgba(245,185,66,.15)]"
                  x={isLeftColumn ? "17" : "52"}
                  y={String(42 + row * 24)}
                  width="27"
                  height="20"
                  rx="4"
                  style={{ animationDelay: delay }}
                />
              );
            })}
          </svg>
        </div>

        <div className="text-center">
          <b className="block text-[27px] font-bold tracking-[.24em] [text-indent:.24em] max-[380px]:text-2xl">
            S4S SIM
          </b>
          <small className="mt-[7px] block font-mono text-[10px] uppercase tracking-[.34em] text-white/50 [text-indent:.34em]">
            Mobile FinTech
          </small>
        </div>
      </div>

      <div className="absolute inset-x-0 bottom-[12%] h-[22px] text-center font-mono text-[13px] tracking-[.05em] text-white/70">
        {statusMessages.map((message, index) => (
          <span
            key={message}
            className="s4s-status-line absolute inset-x-0 opacity-0"
            style={{ animationDelay: `${index * 2.4}s` }}
          >
            {message}
          </span>
        ))}
      </div>

      <style>
        {`
          .s4s-ambient {
            animation: s4s-breathe 2.4s ease-in-out infinite;
          }

          .s4s-ring {
            animation: s4s-ping 2.4s cubic-bezier(.22,.9,.28,1) infinite;
          }

          .s4s-pad {
            animation: s4s-pad 2.4s linear infinite;
          }

          .s4s-status-line {
            animation: s4s-line 7.2s ease-in-out infinite;
          }

          @keyframes s4s-breathe {
            0%, 100% {
              opacity: .55;
              transform: translate(-50%, -50%) scale(.94);
            }
            50% {
              opacity: 1;
              transform: translate(-50%, -50%) scale(1.04);
            }
          }

          @keyframes s4s-ping {
            0%, 38% {
              opacity: 0;
              transform: scale(.55);
            }
            45% {
              opacity: .7;
              transform: scale(.72);
            }
            78%, 100% {
              opacity: 0;
              transform: scale(1.8);
            }
          }

          @keyframes s4s-pad {
            0% {
              fill: rgba(245, 185, 66, .15);
              filter: none;
            }
            10%, 62% {
              fill: #F5B942;
              filter: drop-shadow(0 0 7px rgba(245, 185, 66, .7));
            }
            80%, 100% {
              fill: rgba(245, 185, 66, .15);
              filter: none;
            }
          }

          @keyframes s4s-line {
            0% {
              opacity: 0;
              transform: translateY(7px);
            }
            4%, 28% {
              opacity: 1;
              transform: none;
            }
            33%, 100% {
              opacity: 0;
              transform: translateY(-7px);
            }
          }

          @media (prefers-reduced-motion: reduce) {
            .s4s-ambient,
            .s4s-ring {
              animation: none;
            }

            .s4s-ring {
              opacity: 0;
            }

            .s4s-pad {
              animation: s4s-pad-fade 1.6s ease-in-out infinite alternate;
              animation-delay: 0s !important;
            }

            .s4s-status-line {
              animation-duration: 7.2s;
            }

            @keyframes s4s-pad-fade {
              from {
                fill: rgba(245, 185, 66, .15);
              }
              to {
                fill: #F5B942;
              }
            }
          }
        `}
      </style>
    </div>
  );
};

export default S4SSimLoading;
